<template>
  <v-dialog width="800" v-model="isShow" persistent>
    <v-toolbar dark color="primary">
      <v-toolbar-title>预定详情</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon @click="close">mdi-close</v-icon>
    </v-toolbar>
    <v-card>
      <v-card-text class="pt-2">
        <v-row class="ml-2">
          <v-col cols="6" sm="3" md="3" style="padding: 0px" class="mr-4">
            <v-text-field
              label="领队姓名"
              v-model="userInfo.name"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="4" md="4" style="padding: 0px" class="mr-4">
            <v-text-field
              label="学工号/身份证号"
              v-model="userInfo.id"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4" style="padding: 0px">
            <v-text-field label="电话" v-model="userInfo.tel"></v-text-field>
          </v-col>
            <v-col cols="12" lg="3" md="3" sm="3" style="padding: 0px" v-show="formStyleType != 'GROUP'">
              <v-select
                :items="roles"
                v-model="details.role"
                label="身份"
              ></v-select>
            </v-col>
        </v-row>
        <!--  <v-row v-if="formStyleType != 'GROUP'">
          <v-col cols="12" lg="3" md="3" sm="3">
            <v-checkbox
              v-model="details.isAlumni"
              label="校友"
              style="margin: 0px"
              disabled
            ></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            lg="3"
            md="3"
            sm="3"
            style="padding: 0px"
            v-show="details.isAlumni"
          >
            <v-text-field
              v-model="details.graduateYear"
              label="毕业年份"
              style="margin: 0px"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            lg="4"
            md="4"
            sm="4"
            style="padding: 0px"
            v-show="!details.isAlumni"
          >
            <v-text-field
              v-model="details.zone"
              label="校区"
              style="margin: 0px"
              class="mr-4"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            lg="4"
            md="4"
            sm="4"
            style="padding: 0px"
            v-show="!details.isAlumni"
          >
            <v-text-field
              v-model="details.dept"
              label="单位"
              style="margin: 0px"
            ></v-text-field>
          </v-col>
        </v-row>-->
        <v-row class="ml-2">
          <v-col
            v-show="formStyleType == 'GROUP'"
            cols="6"
            sm="3"
            md="3"
            style="padding: 0px"
            class="mr-4"
          >
            <v-text-field
              label="参观人数"
              v-model="booking.numOfResource"
            ></v-text-field>
          </v-col>
          <v-col
            v-show="formStyleType == 'GROUP'"
            cols="12"
            sm="4"
            md="4"
            style="padding: 0px"
            class="mr-4"
          >
            <v-text-field
              v-model="details.groupName"
              label="团体名称"
            ></v-text-field>
          </v-col>
          <v-col
            v-show="formStyleType == 'GROUP'"
            cols="12"
            sm="4"
            md="4"
            style="padding: 0px"
          >
            <v-text-field
              v-model="details.type"
              label="团体类型"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row
          v-if="formStyleType != 'GROUP'"
          style="padding: 0px; border: 1px solid #9e9e9e"
          class="ma-4 pa-2"
          v-for="item in details.participants"
          :key="item.no"
        >
          <v-col cols="12" sm="2" md="2" style="padding: 0px" class="mr-2">
            <v-text-field label="同行人姓名" v-model="item.name"></v-text-field>
          </v-col>
          <v-col cols="12" sm="5" md="5" style="padding: 0px" class="mr-2">
            <v-text-field label="证件号" v-model="item.id"></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4" style="padding: 0px">
            <v-text-field label="电话" v-model="item.tel"></v-text-field>
          </v-col>
          <v-col cols="12" lg="3" md="3" sm="3">
            <v-checkbox
              v-model="item.isAlumni"
              label="校友"
              style="margin: 0px"
              disabled
            ></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            lg="3"
            md="3"
            sm="3"
            style="padding: 0px"
            v-show="item.isAlumni"
          >
            <v-text-field
              v-model="item.graduateYear"
              label="毕业年份"
              style="margin: 0px"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-card v-show="details.file">
          <v-list flat>
            <v-subheader>已上传文件</v-subheader>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon>mdi-file</v-icon>
              </v-list-item-avatar>

              <v-list-item-content style="text-align: start">
                <v-list-item-title
                  v-html="getHyperLink(details.file)"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-card-text>
      <v-card-actions class="pb-2" v-show="booking.status == '待审批'">
        <v-spacer></v-spacer>
        <v-btn color="error" class="mr-2" @click="opStatus('Reject')"
          >拒绝</v-btn
        >
        <v-btn color="primary" class="mr-2" @click="opStatus('Accept')"
          >同意</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { baseService } from "@/api/base-service";

export default {
  name: "BookingDetailsModal",
  props: { isShow: Boolean, booking: Object, details: Object },
  data: () => {
    return {
      //details: { name: "" },
      userInfo: { name: "", id: "", tel: "" },
      formStyleType: "",
      roles: ['教职工',  '学生']
    };
  },
  methods: {
    close() {
      this.$emit("close", close);
    },
    async opStatus(status) {
      console.log(this.booking);
      console.log(status);
      await baseService.operateStatusByID(this.booking.identity, status);
      alert("操作成功");
      this.$emit("close");
    },
    getHyperLink(file) {
      return "<a href='" + file + "'>" + "申请文件" + "</a>  ";
    },
  },
  watch: {
    booking: {
      handler(val) {
        //console.log(this.booking)
        if (this.booking.description) {
          this.userInfo = this.details.userInfo;
        }
        if (this.booking.type.indexOf("团体") != -1)
          this.formStyleType = "GROUP";
        else this.formStyleType = "INDIVIDUAL";
      },
      deep: true,
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/BookingDetailsModal.vue